import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';
import request from '../../../Helpers/API';
import { Input, Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export const ScorecardSucursal = () => {
  const location = useLocation();
  const history = useHistory();
  const [Cambio, setCambio] = useState([]);
  const [data, setData] = useState([]);
  const [ejercicio, setEjercicio] = useState('');

  const onBack = () => {
    history.push("/Ventas/FiltroScorecardObjetivo")
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CargaScorecardSucursal/MostrarScorecardSucursal?ejercicio=${location.state.ejercicio}&sucursal=${location.state.idsucursal}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
        setCambio(result); // Inicializar nuevosDatos con los datos cargados
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  }, [location.state]);

  const totalMeses = {
    enero: 0, febrero: 0, marzo: 0, abril: 0, mayo: 0, junio: 0,
    julio: 0, agosto: 0, septiembre: 0, octubre: 0, noviembre: 0, diciembre: 0
  };

  data.forEach(item => {
    totalMeses.enero += parseFloat(item.enero) || 0;
    totalMeses.febrero += parseFloat(item.febrero) || 0;
    totalMeses.marzo += parseFloat(item.marzo) || 0;
    totalMeses.abril += parseFloat(item.abril) || 0;
    totalMeses.mayo += parseFloat(item.mayo) || 0;
    totalMeses.junio += parseFloat(item.junio) || 0;
    totalMeses.julio += parseFloat(item.julio) || 0;
    totalMeses.agosto += parseFloat(item.agosto) || 0;
    totalMeses.septiembre += parseFloat(item.septiembre) || 0;
    totalMeses.octubre += parseFloat(item.octubre) || 0;
    totalMeses.noviembre += parseFloat(item.noviembre) || 0;
    totalMeses.diciembre += parseFloat(item.diciembre) || 0;
  });

  const totalGeneral = Object.values(totalMeses).reduce((acc, val) => acc + val, 0);

  return (
    <PlantillaScreen
      titulo={"SCORECARD GENERAL DE SUCURSAL " + location.state.sucursal.toUpperCase() + " " + location.state.ejercicio}
      className_main={1}
      className={"scorecard-sucursal"}
    >
      <LoaderScreen loader={loader} />
      <div className='scorecard-sucursal-encabezado'>
        <div className='scorecard-sucursal-container'>
        </div>
        <div className='scorecard-sucursal-tabla scroll-4'>
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>ID de Línea</th>
                <th>
                  <div>Línea</div>
                </th>
                <th>
                  <div>Enero</div>
                </th>
                <th>
                  <div>Febrero</div>
                </th>
                <th>
                  <div>Marzo</div>
                </th>
                <th>
                  <div>Abril</div>
                </th>
                <th>
                  <div>Mayo</div>
                </th>
                <th>
                  <div>Junio</div>
                </th>
                <th>
                  <div>Julio</div>
                </th>
                <th>
                  <div>Agosto</div>
                </th>
                <th>
                  <div>Septiembre</div>
                </th>
                <th>
                  <div>Octubre</div>
                </th>
                <th>
                  <div>Noviembre</div>
                </th>
                <th>
                  <div>Diciembre</div>
                </th>
                <th>
                  <div>Total</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const total =
                  (parseFloat(item.enero) || 0) +
                  (parseFloat(item.febrero) || 0) +
                  (parseFloat(item.marzo) || 0) +
                  (parseFloat(item.abril) || 0) +
                  (parseFloat(item.mayo) || 0) +
                  (parseFloat(item.junio) || 0) +
                  (parseFloat(item.julio) || 0) +
                  (parseFloat(item.agosto) || 0) +
                  (parseFloat(item.septiembre) || 0) +
                  (parseFloat(item.octubre) || 0) +
                  (parseFloat(item.noviembre) || 0) +
                  (parseFloat(item.diciembre) || 0);

                return (
                  <tr key={index}>
                    <td className='columna-centrada'>{item.idlinea}</td>
                    <td>{item.linea}</td>
                    <td className='columna-centrada'>{item.enero}</td>
                    <td className='columna-centrada'>{item.febrero}</td>
                    <td className='columna-centrada'>{item.marzo}</td>
                    <td className='columna-centrada'>{item.abril}</td>
                    <td className='columna-centrada'>{item.mayo}</td>
                    <td className='columna-centrada'>{item.junio}</td>
                    <td className='columna-centrada'>{item.julio}</td>
                    <td className='columna-centrada'>{item.agosto}</td>
                    <td className='columna-centrada'>{item.septiembre}</td>
                    <td className='columna-centrada'>{item.octubre}</td>
                    <td className='columna-centrada'>{item.noviembre}</td>
                    <td className='columna-centrada'>{item.diciembre}</td>
                    <td className='columna-centrada total'>{total}</td>
                  </tr>
                );
              })}
              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                <td className='columna-centrada total'></td>
                <td className='total'>TOTALES</td>
                <td className='columna-centrada total'>{totalMeses.enero}</td>
                <td className='columna-centrada total'>{totalMeses.febrero}</td>
                <td className='columna-centrada total'>{totalMeses.marzo}</td>
                <td className='columna-centrada total'>{totalMeses.abril}</td>
                <td className='columna-centrada total'>{totalMeses.mayo}</td>
                <td className='columna-centrada total'>{totalMeses.junio}</td>
                <td className='columna-centrada total'>{totalMeses.julio}</td>
                <td className='columna-centrada total'>{totalMeses.agosto}</td>
                <td className='columna-centrada total'>{totalMeses.septiembre}</td>
                <td className='columna-centrada total'>{totalMeses.octubre}</td>
                <td className='columna-centrada total'>{totalMeses.noviembre}</td>
                <td className='columna-centrada total'>{totalMeses.diciembre}</td>
                <td className='columna-centrada total'>{totalGeneral}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='back-filtro'
          onClick={() => onBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
      </div>
    </PlantillaScreen>
  )
}